import { getRouteApi } from '@tanstack/react-router';
import { LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormDateInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormDateInput';
import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import type { SchemaPersonal } from '~/features/leadDetails/schemas/personal.schema.ts';
import { canExecuteApplicantCommand } from '~/features/leadDetails/utils/aclPermissions';

type InDeutschlandSeitProps = {
    antragsteller: 1 | 2;
};

const InDeutschlandSeit: React.FC<InDeutschlandSeitProps> = ({ antragsteller }) => {
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const { t } = useTranslation();
    const { control } = useFormContext<SchemaPersonal>();

    return (
        <FormDateInput
            control={control}
            id={`antragsteller${antragsteller}.personendaten.inDeutschlandSeit`}
            label={t('PERSONAL_DATA.IN_GERMANY_SINCE')}
            disabled={
                !canExecuteApplicantCommand({
                    applicant: antragsteller,
                    commandName: LOAN_REQUEST_COMMANDS.updateApplicantResidenceData,
                    permissions,
                })
            }
        />
    );
};

export default InDeutschlandSeit;
